import { WSElement } from "@wingspanhq/fe-component-library";
import { PayerRow, PayeeEngagement } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";
import { selectorSearchRowName } from "../../../shared/selectors/selectorSearchRowName";
import { DataView } from "../../../shared/components/DataView";

type Props = {
  shimmer?: boolean;
  payerRow?: PayerRow;
  payerPayeeEngagement?: Pick<PayeeEngagement, "engagementName">;
};

export const WorkLogEngagementDetails: React.FC<Props> = props => {
  const engagementPreview = useMemo(() => {
    if (!props.payerRow) {
      return;
    }
    if (!props.payerPayeeEngagement) {
      return;
    }

    return {
      name: selectorSearchRowName(props.payerRow),
      company:
        props.payerRow.profile?.doingBusinessAs ??
        props.payerRow.profile?.companyName,
      email: props.payerRow.email ?? undefined,
      engagementName: props.payerPayeeEngagement.engagementName
    };
  }, [props.payerRow, props.payerPayeeEngagement]);

  return (
    <WSElement>
      <DataView
        shimmer={props.shimmer}
        data={[
          {
            label: "Contact name",
            value: engagementPreview?.name
          },
          {
            label: "Client company",
            value: engagementPreview?.company
          },
          {
            label: "Contact email",
            value: engagementPreview?.email
          },
          {
            label: "Assignment name",
            value: engagementPreview?.engagementName
          }
        ]}
      />
    </WSElement>
  );
};
